module.exports = __webpack_public_path__ + "94a1d943f050484a35a24b0b09b76be7.svg";